import { render, staticRenderFns } from "./MenuDebits.vue?vue&type=template&id=746e0014&scoped=true"
import script from "./MenuDebits.vue?vue&type=script&lang=js"
export * from "./MenuDebits.vue?vue&type=script&lang=js"
import style0 from "./MenuDebits.vue?vue&type=style&index=0&id=746e0014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e0014",
  null
  
)

export default component.exports